import { BaseNode } from './BaseNode';

export function TokenLookupNode({ data }: { data: { label: string; tool?: string; alias?: string } }) {
  return <BaseNode type="token-lookup" label={data.label} alias={data.alias} lines={[{ text: data.tool }]} />;
}
